const router =  {
    mode:'history',
    base:'/web/',
    routes: [
      {
        path:'/capture',
        component: () => import('./views/Capture.vue'),
      },
      {
        path:'/upload',
        component: () => import('./views/Upload.vue'),
      },
      {
        path:'/process',
        component: () => import('./views/Process.vue'),
      },
      {
        path:'/download',
        component: () => import('./views/Download.vue'),
      },
      {
        path:'/home',
        component: () => import('./views/Home.vue'),
      },
      { path: '/', redirect: '/home' }
    ]
  }
  
  export default router;
  